(function () {
    'use strict';

    /*
     MyOrderListController
    -------------------------------------------------------------------------- */

    angular
        .module('PublicApp.Order.list', [])
        .controller('MyOrderListController', [
            '$scope',
            '__DataStore',
            'appServices',
            '$stateParams',
            '__Auth',
            '__Utils',
            MyOrderListController
        ]);

    /**
      * MyOrderListController for manage product list
      *
      * @inject $scope
      * @inject __DataStore
      * @inject appServices
      * @inject $stateParams
      * @inject __Auth
      * 
      * @return void
      *-------------------------------------------------------- */

    function MyOrderListController($scope, __DataStore, appServices, $stateParams, __Auth, __Utils) {

        var scope = this;

        var dtCartOrderColumnsData = [
            {
                "name": "order_uid",
                "orderable": true,
                "template": "#orderColumnIdTemplate"
            },
            {
                "name": "status",
                "orderable": true,
                "template": "#orderStatusColumnIdTemplate"
            },
            {
                "name": "creation_date",
                "orderable": true,
                "template": "#orderColumnTimeTemplate"
            },
            {
                "name": null,
                "template": "#orderActionColumnTemplate"
            }
        ],
            tabs = {
                'activeTab': {
                    id: 'activeTabList',
                    status: 1
                },
                'cancelled': {
                    id: 'cancelledTabList',
                    status: 3
                },
                'completed': {
                    id: 'completedTabList',
                    status: 6
                }
            };

        // Fired when clicking on tab    
        $('#adminOrderList a').click(function (e) {

            e.preventDefault();

            var $this = $(this),
                tabName = $this.attr('aria-controls'),
                selectedTab = tabs[tabName];

            if (!_.isEmpty(selectedTab)) {
                $(this).tab('show')
                scope.getOrders(selectedTab.id, selectedTab.status);
            }

        });


        /**
          * get orders list
          *
          * @param number tableID
          * @param number status
          *
          * @return void
          *---------------------------------------------------------------- */

        scope.getOrders = function (tableID, status) {

            // destroy if existing instatnce available
            if (scope.cartOrderListDataTable) {
                scope.cartOrderListDataTable.destroy();
            }

            scope.cartOrderListDataTable = __DataStore.dataTable('#' + tableID, {
                url: {
                    'apiURL': 'cart.get.orders.data',
                    'status': status
                },
                dtOptions: {
                    "searching": true,
                    "order": [[2, "desc"]],
                    "columnDefs": [
                        {
                            "targets": [1],
                            "searchable": false
                        }
                    ]
                },
                columnsData: dtCartOrderColumnsData,
                scope: $scope
            });
        };

        // scope.getOrders('activeTabList', 1);
        var selectedTab = $('.nav li a[href="#activeTab"]');

        selectedTab.triggerHandler('click', true);

        /*
	     Reload current datatable
	    -------------------------------------------------------------------- */

        scope.reloadDT = function () {
            __DataStore.reloadDT(scope.cartOrderListDataTable);
        };

        /**
         * update order dialog
         * 
         * @param orderID
         * @param isAdmin
         * 
         * @return void
         *---------------------------------------------------------------- */
        scope.cancelDialog = function (orderID) {

            __DataStore.fetch({
                'apiURL': 'cart.order.cancel',
                'orderID': orderID
            })
                .success(function (responseData) {

                    appServices.processResponse(responseData, null, function () {

                        var requestData = responseData.data;

                        appServices.showDialog({
                            orderData: requestData.order
                        },
                            {
                                templateUrl: __globals.getTemplateURL(
                                    'order.user.cancel'
                                )
                            },
                            function (promiseObj) {

                                // Check if category updated
                                if (_.has(promiseObj.value, 'order_updated')
                                    && promiseObj.value.order_updated === true) {
                                    scope.reloadDT();
                                }

                            });

                    });

                });

        };

    };

})();